module.exports = __webpack_public_path__ + "static/Nanopesos0-c19838d0443e8d7b956eeb29ab97e270.webp";